<nz-card>
  <app-table-wrap>
    <ng-container content-selector="filterTableWrapTmpl">
      <div class="d-flex w-100">
        <div class="d-flex w-100">
          <nz-date-picker class="w-100 m-l-10 m-r-10" maskDate nzPlaceHolder="Từ ngày"
                          [(ngModel)]="filter.fromDate"
                          [nzDisabledDate]="disabledFromDate"
                          (ngModelChange)="filterChange($event)"></nz-date-picker>
          <nz-date-picker class="w-100 m-l-10 m-r-10" maskDate nzPlaceHolder="Đến ngày"
                          [nzDisabledDate]="disabledToDate"
                          [(ngModel)]="filter.toDate"
                          (ngModelChange)="filterChange($event)"></nz-date-picker>

          <nz-select class="w-100 m-l-10 m-r-10" nzPlaceHolder="Kênh bán hàng" [(ngModel)]="filter.channel" (ngModelChange)="filterChange($event)">
            <nz-option nzLabel="Tất cả" [nzValue]="null"></nz-option>
            <nz-option [nzLabel]="'Trang cá nhân'" [nzValue]="1"></nz-option>
            <nz-option [nzLabel]="'Page'" [nzValue]="2"></nz-option>
            <nz-option [nzLabel]="'Khách lẻ'" [nzValue]="3"></nz-option>
          </nz-select>

            <nz-select class="w-100 m-l-10 m-r-10" nzPlaceHolder="Kênh thanh toán" [(ngModel)]="filter.channelPayment" (ngModelChange)="filterChange($event)">
                <nz-option nzLabel="Tất cả" [nzValue]="null"></nz-option>
                <nz-option [nzLabel]="'Chuyển khoản'" [nzValue]="1"></nz-option>
                <nz-option [nzLabel]="'Ship thu'" [nzValue]="2"></nz-option>
                <nz-option [nzLabel]="'Tiền mặt'" [nzValue]="3"></nz-option>
            </nz-select>
          <nz-select class="w-100 m-l-10 m-r-10" nzPlaceHolder="Loại báo cáo" [(ngModel)]="filter.dateOrder" (ngModelChange)="filterChange($event)">
            <nz-option [nzLabel]="'Theo ngày'"  [nzValue]="'DATE'"></nz-option>
            <nz-option [nzLabel]="'Theo tháng'" [nzValue]="'MONTH'"></nz-option>
          </nz-select>
        </div>


      </div>

    </ng-container>
    <div id="chart">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [markers]="chartOptions.markers"
        [stroke]="chartOptions.stroke"
        [yaxis]="chartOptions.yaxis"
        [dataLabels]="chartOptions.dataLabels"
        [title]="chartOptions.title"
        [fill]="chartOptions.fill"
        [tooltip]="chartOptions.tooltip"
        [legend]="chartOptions.legend"
      ></apx-chart>
    </div>
    <div>
      <nz-row [nzGutter]="16">
        <nz-col [nzSpan]="12">
          <nz-statistic [nzValue]="(totalOrder | number)!" [nzTitle]="'Tổng đơn hàng'"></nz-statistic>
        </nz-col>
        <nz-col [nzSpan]="12">
          <nz-statistic [nzValue]="(totalAmount | number: '1.0-2')!" [nzTitle]="'Tổng tiền'"></nz-statistic>
        </nz-col>
      </nz-row>
    </div>
    <div>
      <app-table [tableConfig]="tableConfig"
                 [tableData]="reportList"
                 [changeDetect]="tableConfig.loading"
                 (changePageNum)='summaryOrder()'
                 (doSort)="summaryOrder(false, $event)"
      >
        <!--        Filter    -->
        <!--       -->
        <!--  Custom Row      -->

      </app-table>


    </div>
  </app-table-wrap>
</nz-card>

<ng-template #suffixIconSearch>
  <span nz-icon nzType="search"></span>
</ng-template>
